import { H2RButton, H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { imageTypesDefinitions } from "../../imports";
import OpenExternal from "../helpers/OpenExternal";
import { ReplaceWithDataSource } from "../helpers/variable";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	return (
		<>
			<H2RSelect
				label="Score levels"
				selected={`${cue.levels}`}
				css="mb-2"
				options={[
					{ label: 'Hide all levels', value: "0" },
					{ label: 1, value: "1" },
					{ label: 2, value: "2" },
					{ label: 3, value: "3" },
					{ label: 4, value: "4" },
					{ label: 5, value: "5" },
					{ label: 6, value: "6" },
				]}
				onChange={(change) => {
					onUpdate({ levels: parseInt(change) });
				}}
			/>

			<H2RSelect
				label="Team symbol"
				selected={cue.symbol || "colour"}
				css="mb-2"
				options={[
					{ label: "Colour", value: "colour" },
					{ label: "Image", value: "image" },
				]}
				onChange={(change) => {
					onUpdate({ symbol: change });
				}}
			/>
			<H2RSelect
				label="Active team"
				selected={`${cue.activeTeam}`}
				css="mb-2"
				options={[
					{ label: "None", value: "none" },
					{ label: 1, value: "1" },
					{ label: 2, value: "2" },
				]}
				onChange={(change) => {
					onUpdate({ activeTeam: parseInt(change) });
				}}
			/>
			<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
			{cue.teams.map((t, i) => {
				return (
					<div key={i}>
						<span>Team {i + 1}</span>
						<div className="mb-4 flex flex-col max-w-sm">
							<div className="flex max-w-sm space-x-3">
								<H2RInput
									label={`Name (Large text)`}
									placeholder="Team name"
									value={t.name}
									onChange={(value) => {
										onUpdate({
											teams: [
												...cue.teams.map((t, id) => {
													if (id === i) {
														return {
															...t,
															name: value,
														};
													} else {
														return t;
													}
												}),
											],
										});
									}}
								/>
							</div>

							{cue.symbol === "image" ? (
								<>
									<H2RSelect
										selected={t.image}
										label="Team image"
										options={
											media.length === 0
												? [
														{
															label: "Add images in the Media tab",
															value: ``,
															disabled: true,
														},
												  ]
												: [
														...media
															.filter((item) =>
																imageTypesDefinitions.includes(item.mimetype)
															)
															.map((item) => {
																return {
																	label: item.originalname,
																	value: item.filename,
																};
															}),
												  ]
										}
										onChange={(value) => {
											onUpdate({
												teams: [
													...cue.teams.map((t, id) => {
														if (id === i) {
															return {
																...t,
																image: value,
															};
														} else {
															return t;
														}
													}),
												],
											});
										}}
									/>
									{/* <ImagePreview image={cue.customImage} /> */}
								</>
							) : (
								<H2RInput
									label={`Colour`}
									value={t.colour}
									colourPicker={true}
									onChange={(value) => {
										onUpdate({
											teams: [
												...cue.teams.map((t, id) => {
													if (id === i) {
														return {
															...t,
															colour: value,
														};
													} else {
														return t;
													}
												}),
											],
										});
									}}
								/>
							)}
						</div>
					</div>
				);
			})}

			<H2RInput
				label={`Delimiter`}
				value={cue.delimiter}
				placeholder="Ex: Place an '|' between each score"
				onChange={(value) => {
					onUpdate({ delimiter: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis  max-w-xs md:max-w-sm lg:max-w-lg  overflow-hidden">
			<span className="font-semibold ">
				{cue.teams.map((t, i) => {
					if (i === 0) {
						return (
							<>
								<ReplaceWithDataSource text={t.name} keepBrakets={true} /> vs{" "}
							</>
						);
					} else {
						return <ReplaceWithDataSource text={t.name} keepBrakets={true}/>;
					}
				}) || ""}
			</span>
		</div>
	);
};
